import React, { useState } from "react";
import { mergeStyleSets, css, TooltipHost, TooltipOverflowMode, Icon } from '@fluentui/react';
import { OverflowSet } from '@fluentui/react/lib/OverflowSet';
import List from '../../../Templates/List';
import DisabledCard from '../../../Templates/CCard/DisabledCard';
import { useTranslation } from "react-i18next";
import { Card, Row, Col } from "react-bootstrap"
import { Toggle } from '@fluentui/react/lib/Toggle';
import { __ListViewMode } from '../../../../common/Dictionaries';
import { useGetPartyUsersByBookId } from '../../../../hooks/services/sBook/useOfParty'
import NoDataLayer from "../../../Common/NoDataLayer";
import { deleteSectionPartyUserById, disableSectionPartyUserById } from "../../../../services/sBook/section-party.service";
import Message from "../../../Common/Message";
import ListPagination from "../../../Templates/List/ListPagination";
import { useUpdateUserBookData } from "../../../../hooks/component/sBook/useOfBookuserBox";
import { __onRenderOverflowItem, __onRenderOverflowButton } from "../../../../common/CommonFuctions";

function BookUsersBox(props) {
    const { t } = useTranslation();

    //Parametros de entrada.

    const inputParam_BookObject = props.bookObject;
    const inputParam_BookPartyList = props.bookPartyList;
    const inputParam_RoleList = props.roleList;
    const inputParam_SelectedPartyCardId = props.selectedPartyCard !== null && props.selectedPartyCard.id !== undefined ? props.selectedPartyCard.id : null;
    const inputParam_EditMode = props.editMode !== null && props.editMode !== undefined ? props.editMode : true;
    const inputParam_FireGetBookUsers = props.fireGetBookUsers !== null && props.fireGetBookUsers !== undefined ? props.fireGetBookUsers : false;
    const inputParam_SetterFireGetBookUsers = props.setterFireGetBookUsers !== null && props.setterFireGetBookUsers !== undefined ? props.setterFireGetBookUsers : null;
    const inputParam_SetterBookUsersCount = props.setterBookUsersCount !== null && props.setterBookUsersCount !== undefined ? props.setterBookUsersCount : null;
    const inputParam_UserHasConfigRoleAction = props.userHasConfigRoleAction !== null && props.userHasConfigRoleAction !== undefined ? props.userHasConfigRoleAction : false;
    const inputParam_IsCreatrionMode = props.isCreatrionMode !== null && props.isCreatrionMode !== undefined ? props.isCreatrionMode : false;
    
    const inputParam_SetPartySectionCardIsSelected = props.setPartyCardIsSelected !== null && props.setPartyCardIsSelected !== undefined ? props.setPartyCardIsSelected : null;
    const inputParam_PartyCardIsSelected = props.partyCardIsSelected !== null && props.partyCardIsSelected !== undefined ? props.partyCardIsSelected : null;


    const [successful, setSuccessful] = useState(null);
    const [message, setMessage] = useState(null);
    const [messageType, setMessageType] = useState(null);
    const [showMessage, setShowMessage] = useState(false);

    const [tglListViewMode, setTglListViewMode] = useState(__ListViewMode.All);


    const [usersBookData, setUsersBookData] = useState({fireUpdate: true, data: null, pageNumber: 1, pageSize: 10, filters: []});
    useGetPartyUsersByBookId(inputParam_BookObject.id, usersBookData, setUsersBookData, inputParam_FireGetBookUsers, inputParam_SetterFireGetBookUsers, inputParam_SetterBookUsersCount);

    const [filtredPartyArray, setFiltredPartyArray] = useState(usersBookData.data && tglListViewMode === __ListViewMode.Specific ? {fireUpdate: true, data: usersBookData.data.filter(x => x["partyId"] === inputParam_SelectedPartyCardId), pageNumber: 1, pageSize: 10, filters: []} : { fireUpdate: true, data: null });


    useUpdateUserBookData(usersBookData, setUsersBookData, filtredPartyArray, setFiltredPartyArray, inputParam_SelectedPartyCardId, tglListViewMode, inputParam_PartyCardIsSelected, inputParam_SetPartySectionCardIsSelected);


    const onDeleteUserFromBookClick = (item) => {
        deleteSectionPartyUserById(item.id).then((response) => {
            //No se elimina desde listado ya que esto lo hace #CUSTOMDELETE# (Buscar en este archivo).
            //De lo contrario tendría dos cosas iguales.

            if (response.data.succeeded) {
                setUsersBookData({fireUpdate: true, data: null, pageNumber: 1, pageSize: 10, filters: []})
                setFiltredPartyArray(usersBookData.data && tglListViewMode === __ListViewMode.Specific ? {fireUpdate: true, data: usersBookData.data.filter(x => x["partyId"] === inputParam_SelectedPartyCardId), pageNumber: 1, pageSize: 10, filters: []} : { fireUpdate: true, data: null })
            }
            else {
                setShowMessage(true)
                setSuccessful(false);
                setMessageType("error");
                setMessage(t('data-lang-msg-operationerror'))
            }
        }).catch(() => {
            setShowMessage(true)
            setSuccessful(false);
            setMessageType("error");
            setMessage(t('data-lang-msg-operationerror'))
        });
    }

    const onDisableUserFromBookClick = (item) => {
        disableSectionPartyUserById(item.partyMemberId).then((response) => {
            //No se elimina desde listado ya que esto lo hace #CUSTOMDELETE# (Buscar en este archivo).
            //De lo contrario tendría dos cosas iguales.

            if (response.data.data) {
                setUsersBookData({fireUpdate: true, data: null, pageNumber: 1, pageSize: 10, filters: []})
                setFiltredPartyArray(usersBookData.data && tglListViewMode === __ListViewMode.Specific ? {fireUpdate: true, data: usersBookData.data.filter(x => x["partyId"] === inputParam_SelectedPartyCardId), pageNumber: 1, pageSize: 10, filters: []} : { fireUpdate: true, data: null })
            }
            else {
                setShowMessage(true)
                setSuccessful(false);
                setMessageType("error");
                setMessage(t('data-lang-msg-operationerror'))
            }
        }).catch((ex) => {
            setShowMessage(true)
            setSuccessful(false);
            setMessageType("error");
            setMessage(t('data-lang-msg-operationerror'))
        });
    }

    const onListViewModeChange = (e, checked) => {

        if (!checked) {
            if (inputParam_SelectedPartyCardId === null) {
                setShowMessage(true)
                setSuccessful(true);
                setMessageType("warning");
                setMessage(t('data-lang-msg-selectaparty'))
            }
            else {
                setShowMessage(false)
            }
        } else {
            setShowMessage(false)
        }

        setTglListViewMode(checked ? __ListViewMode.All : __ListViewMode.Specific)
        setUsersBookData({fireUpdate: true, data: null, pageNumber: 1, pageSize: 10, filters: []});
        setFiltredPartyArray({fireUpdate: true, data: null});
        inputParam_SetPartySectionCardIsSelected && inputParam_SetPartySectionCardIsSelected(true);
    }
    const classNames = mergeStyleSets({
        overflow: {
          overflow: 'hidden',
          textOverflow: 'ellipsis',
        },
    });
    const _columns = (inputParam_RoleList && inputParam_BookPartyList && inputParam_BookPartyList.data === null) ? [] : [
        {
            key: 'username',
            //key: 'userName',
            name: t('data-lang-lbl-username'),
            fieldName: 'username',
            minWidth: 100,
            maxWidth: 170,
            onRender:(item) => {
                return  <TooltipHost content={ item.username } >
                            <div>{ item.items[0].fullname }</div>
                        </TooltipHost>  
            }
        },
        {  
            key: 'id',
            fieldName: 'username',
            maxWidth: 500,
            onRender:(userPermission, row) => {

                let itemsOrdered = userPermission.items.sort(function(a, b) { return a.sectionName.localeCompare(b.sectionName) })

                return <table style={{width: "100%"}}>
                            <thead>
                                <tr>
                                    <td style={{minWidth: "80px", width: "180px"}}>
                                        {t('data-lang-lbl-party')}
                                    </td>
                                    <td style={{minWidth: "80px", width: "150px"}}>
                                        {t('data-lang-lbl-section')}
                                    </td>
                                    <td style={{width: "70px"}}>
                                        {t('data-lang-lbl-role')}
                                    </td>
                                    <td style={{width: "70px"}}>
                                        {t('data-lang-lbl-actions')}
                                    </td>
                                </tr>
                            </thead>
                            <tbody>
                                {
                                    itemsOrdered.map((userPermissionOrdered, index) => (
                                        <tr key={index}>
                                            <td>
                                                <TooltipHost
                                                    content={ userPermissionOrdered.partyName }
                                                    overflowMode={TooltipOverflowMode.Self}
                                                    hostClassName={css(classNames.overflow)}
                                                    onTooltipToggle={false}
                                                    styles={{
                                                        root: { display: 'block', minWidth: "80px", width: "180px" },
                                                    }}
                                                >
                                                    <div>
                                                        {userPermissionOrdered.partyName}
                                                    </div>
                                                </TooltipHost>
                                            </td>
                                            <td>
                                                <TooltipHost
                                                    content={ userPermissionOrdered.sectionName }
                                                    overflowMode={TooltipOverflowMode.Self}
                                                    hostClassName={css(classNames.overflow)}
                                                    onTooltipToggle={false}
                                                    styles={{
                                                        root: { display: 'block', minWidth: "80px", width: "150px" },
                                                    }}
                                                >
                                                    <div>
                                                        {userPermissionOrdered.sectionName}
                                                    </div>
                                                </TooltipHost>
                                            </td>
                                            <td>
                                                {userPermissionOrdered.roleName}
                                            </td>
                                            {!inputParam_EditMode &&
                                            <td>
                                                <TooltipHost content={ userPermissionOrdered.deactivate ? t('data-lang-lbl-disabled') : t('data-lang-lbl-enabled') } >
                                                    <Icon styles={{root: {fontSize: '16px', fontFamily: 'FabricMDL2Icons'}}} iconName={userPermissionOrdered.deactivate ? 'Blocked' : 'SkypeCircleCheck'} />
                                                </TooltipHost>  
                                            </td>
                                            }
                                            {inputParam_EditMode && (inputParam_IsCreatrionMode ? true : inputParam_UserHasConfigRoleAction) &&
                                                <td>
                                                    <div>
                                                        <OverflowSet
                                                            className="action-menu-list-toolbar d-flex justify-content-center list-menu-action"
                                                            role="menubar"
                                                            items={[
                                                                {
                                                                    key: 'delete',
                                                                    icon: 'Delete',
                                                                    name: t('data-lang-btn-delete'),
                                                                    title: t('data-lang-btn-delete'),
                                                                    onClick: () => onDeleteUserFromBookClick(userPermissionOrdered),
                                                                },
                                                                /*{
                                                                    key: 'enabledisable',
                                                                    icon: userPermissionOrdered.deactivate ? 'Blocked' : 'SkypeCircleCheck',
                                                                    name: userPermissionOrdered.deactivate ? t('data-lang-btn-enable') : t('data-lang-btn-disable'),
                                                                    title: userPermissionOrdered.deactivate ? t('data-lang-btn-enable') : t('data-lang-btn-disable'),
                                                                    onClick: () => onDisableUserFromBookClick(userPermissionOrdered),
                                                                }*/
                                                            ]}
                                                            onRenderOverflowButton={__onRenderOverflowButton}
                                                            onRenderItem={__onRenderOverflowItem}
                                                        />
                                                    </div>
                                                </td>
                                            }
                                        </tr>
                                    ))
                                }
                            </tbody>
                            

                        </table>
            }
        }
    ];

    const displaySectionRolesBox = inputParam_BookObject.id !== null ? true : false;

    return (
        <Card className='h-100'>
            <DisabledCard display={ !displaySectionRolesBox } />
            <Card.Header className="card-header-compact">
                <Card.Title className="d-flex justify-content-between">
                    <b>{t('data-lang-boxname-roles')}</b>
                </Card.Title>
            </Card.Header>
            <Card.Footer style={{ display: displaySectionRolesBox ? "block" : "none", padding: "0px", minHeight:"46px", borderBottom: "1px solid rgba(0, 0, 0, 0.125)" }} >
                <div className='book-toolbar d-flex float-end'>
                {   displaySectionRolesBox &&
                    <Toggle
                        checked={ tglListViewMode === __ListViewMode.All ? true : false }
                        onChange={ onListViewModeChange }
                        role="checkbox"
                        onText={t('data-lang-lbl-all')}
                        offText={t('data-lang-lbl-party')}
                        styles={ {root:{paddingTop: "14px", float: "right", display: "flex"}, label: {marginRight : "25px", padding: "0px, 10px"}} }
                    />
                }
                </div>
            </Card.Footer>
            <Card.Body style={{width: "100%"}} className="overflow-auto h-100">         
                <Row className='layerBlockedContent'>
                    <Col>
                        {
                            displaySectionRolesBox && (inputParam_RoleList && inputParam_BookPartyList && inputParam_BookPartyList.data) &&
                            <>
                                <List
                                    manipulateLocalData={ true }
                                    listLocalStoragePageSizeVariableName="usersBook"
                                    className="no-compact-list big-header"
                                    data={
                                        filtredPartyArray.data !== null && tglListViewMode === __ListViewMode.Specific ?
                                        (filtredPartyArray.data  !== null ? filtredPartyArray : (usersBookData !== null ? usersBookData : [])) : usersBookData !== null ? usersBookData
                                    :   []
                                    }
                                    setData={
                                        filtredPartyArray.data !== null && tglListViewMode === __ListViewMode.Specific ?
                                        (filtredPartyArray.data  !== null ? setFiltredPartyArray : (usersBookData !== null ? setUsersBookData : [])) : usersBookData !== null ? setUsersBookData
                                    :   null
                                    } columns={_columns} />
                            </>
                        }
                        <NoDataLayer display={ !displaySectionRolesBox } />
                    </Col>
                </Row>
            </Card.Body>
            <Card.Footer>
                {
                    displaySectionRolesBox && (inputParam_RoleList && inputParam_BookPartyList && inputParam_BookPartyList.data) &&
                    <ListPagination
                        listLocalStoragePageSizeVariableName="usersBook"
                        data={
                            filtredPartyArray.data !== null && tglListViewMode === __ListViewMode.Specific ?
                            (filtredPartyArray.data  !== null ? filtredPartyArray : (usersBookData !== null ? usersBookData : [])) : usersBookData !== null ? usersBookData
                        :   []
                        }
                        setData={
                            filtredPartyArray.data !== null && tglListViewMode === __ListViewMode.Specific ?
                            (filtredPartyArray.data  !== null ? setFiltredPartyArray : (usersBookData !== null ? setUsersBookData : [])) : usersBookData !== null ? setUsersBookData
                        :   null }
                     />
                }
                <Message message={ message } display={ successful === null? false : showMessage } messageType={ messageType } setterShowMessage={ setShowMessage } />
            </Card.Footer>
        </Card>
    );
}

export default BookUsersBox;

